// Admin API client — /admin/billing/* (mirrors the API's billing aggregate).

import type { AdminBillingMetrics } from '@a7y/types';
import { client, PaginatedResponse } from './transport';

export const billingApi = {
  // Billing
  getBillingMetrics: () => client.get<AdminBillingMetrics>('/billing/metrics'),
  getBillingHistory: (params?: { page?: number; limit?: number }) =>
    client.get<PaginatedResponse<Record<string, unknown>>>(
      `/billing/history?${new URLSearchParams(params as Record<string, string>)}`
    ),
};
